import PropTypes from 'prop-types';
import React from 'react';
import SummaryNumber from 'components/VisualizationStrategies/SummaryNumber';
import CardHeader from '../shared/CardHeader';
import phoenixRender, {SIZES, PARTS} from './phoenixRender';
import './ChartPreview.css';

const HEIGHT = 360;
const WIDTH = 320;

const ChartPreview = ({card, chartRender}) => (
  <div className="ChartPreview">
    <CardHeader card={card} />
    {chartRender && chartRender.summary ? (
      <div className="ChartPreview__SummaryNumber">
        <SummaryNumber
          number={chartRender.summary.value}
          label={chartRender.summary.label}
        />
      </div>
    ) : null}
    {chartRender && chartRender.image ? (
      <img
        className="ChartPreview__Chart"
        src={`data:image/png;base64,${chartRender.image.data}`}
      />
    ) : null}
  </div>
);

ChartPreview.propTypes = {
  card: PropTypes.object.isRequired,
};

export default phoenixRender(() => ({
  width: WIDTH,
  height: HEIGHT,
  size: `${SIZES.DETAILS}:${WIDTH}:${HEIGHT}`,
  parts: [PARTS.IMAGE, PARTS.SUMMARY],
}))(ChartPreview);
